import { API_URL } from '../constants/api';
import tokenStore from './tokenStore';

/**
 * Fire-and-forget product analytics event to MongoDB.
 * Safe to call anywhere — never throws, never blocks UI.
 *
 * @param {string} event  e.g. "page_view", "login", "onboarding_complete"
 * @param {object} meta   arbitrary key/value context (e.g. { tab: "today" })
 */
export const logEvent = (event, meta = {}) => {
  const token = tokenStore.get();
  if (!token) return;
  fetch(`${API_URL}/api/track`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ event, meta }),
  }).catch(() => {});
};
